module.exports = __webpack_public_path__ + "static/media/brush.b6248a6d.svg";